<template>
  <div id="main">
    <div id="banner">
      <img class="banner-bg" v-lazy='require("@/assets/img/about/contact/banner-bg.png")'>
      <img class="banner-center" v-lazy='require("@/assets/img/about/banner-center.png")'>
      <p class="banner-title">每一次沟通 都有温度</p>
    </div>
    <div id="info">
      <img class="info-logo" v-lazy='require("@/assets/img/about/contact/logo.png")'>
      <img class="info-qrcode" v-lazy='require("@/assets/img/index/qrcode-wechat.png")'>
      <p class="info-qrcode-desc">扫描二维码<br />关注澜渟微信公众号</p>
      <p class="info-qrcode-wetchat">微信号：WrightinHealth</p>
      <p class="info-title name">公司名称</p>
      <p class="info-desc name">南京麦豆健康科技有限公司</p>
      <p class="info-title address">地址</p>
      <p class="info-desc address">南京市雨花台区凤展路32号A2北栋7层</p>
      <p class="info-title phone">电话</p>
      <p class="info-desc phone-hotline" @click='goPhone("400-133-5668")'>服务热线：400-133-5668</p>
      <p class="info-desc phone-business" @click='goPhone("17372217350")'>经销合作：17372217350</p>
      <p class="info-title email">邮箱</p>
      <p class="info-desc email">support@medoht.com</p>
    </div>
    <div id="map">
      <baidu-map class="baiduMap" :center="position" :zoom="15" :scroll-wheel-zoom="true"
                 ak="7sTPX5Pn0xrZpvpXZ6dKG99i8aiK4fG9">
        <bm-marker :position="position" :icon="markIcon">
          <bm-info-window :show="true">
            <p class="map-company">南京麦豆健康科技有限公司</p>
            <p class="map-address">南京市雨花台区凤展路32号A2北栋7层</p>
          </bm-info-window>
        </bm-marker>
      </baidu-map>
    </div>
    <div class="append">
      <div class="left" @click='goPhone("17372217350")'>
        <img :src="require('@/assets/img/about/contact/phone.png')" alt />
        <p>电话联系</p>
      </div>
      <div class="right" @click="isShowFill=true">
        立即咨询
      </div>
    </div>

    <md-custom :show.sync="isShowFill" id="popup" type="grey">
      <div v-if="isSubmitSuccess" class="fill-success">
        <img class="icon" :src="require('@/assets/img/about/contact/success.png')" />
        <p class="text">提交成功</p>
        <img @click="isShowFill=false;isSubmitSuccess=false;" class="close" :src="require('@/assets/img/about/contact/close.png')" />
      </div>
      <div v-else class="fill-content">
        <p class="title">填写信息</p>
        <div class="fill-form">
          <input class="input" type="text" placeholder="*请填写您的姓名" maxlength="6" v-model="fillName">
        </div>
        <div class="fill-form">
          <input class="input" type="text" placeholder="*请填写手机号" maxlength="11" v-model="fillPhone">
        </div>
        <p class="error-text">{{tip}}</p>
        <div class="submit-btn" @click="submitFill">提交</div>
        <div class="tip">提交信息后，我们将在 <span>3</span> 个工作日内跟您联系，请保持手机畅通</div>
        <img @click="isShowFill=false;isSubmitSuccess=false;" class="close" :src="require('@/assets/img/about/contact/close.png')" />
      </div>
    </md-custom>
    <md-custom :show.sync="loading" id="load" type="transparent">
    </md-custom>
  </div>
</template>

<script>
import BaiduMap from "vue-baidu-map/components/map/Map.vue";
import BmMarker from "vue-baidu-map/components/overlays/Marker.vue";
import BmInfoWindow from "vue-baidu-map/components/overlays/InfoWindow.vue";
import MdCustom from "../../components/custom/src/custom";

export default {
  data() {
    return {
      position: {
        lng: 118.748334,
        lat: 31.943822
      },
      markIcon: {
        url: require("@/assets/img/about/contact/position.png"),
        size: {
          width: 18,
          height: 24
        }
      },
      loading: false,
      isShowFill: false,
      isSubmitSuccess: false,
      fillName: '',
      fillPhone: '',
      tip: '',
    };
  },
  mounted() {
    window.scrollTo(0, 0);
  },
  methods: {
    /**
     拨打电话
     @param {string} phone 电话号码
     @return
     */
    goPhone(phone) {
      window.location.href = `tel:${phone}`;
    },

    submitFill() {
      if (this.fillName === '') {
        this.tip = '*请填写您的姓名';
        return;
      }
      if (this.fillPhone === '') {
        this.tip = '*请填写正确的手机号格式';
        return;
      }
      // 正则 1+[0-9]{10}
      if (!/^1[0-9]{10}$/.test(this.fillPhone)) {
        this.tip = '*请填写正确的手机号格式';
        return;
      }

      this.tip = '';
      this.loading = true;
      this.$axios.post(`${this.$request.live}/common/pc/fill-info`, {
        name: this.fillName,
        phone: this.fillPhone,
      }).then(res => {
        this.loading = false;
        this.isSubmitSuccess = true;
        this.fillName = '';
        this.fillPhone = '';
      });
    },
  },
  components: {
    BaiduMap,
    BmMarker,
    BmInfoWindow,
    MdCustom
  }
};
</script>

<style lang="scss" scoped>
#banner {
  position: relative;
  height: 18rem;

  > .banner-bg {
    position: absolute;
    z-index: 1;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  > .banner-center {
    position: absolute;
    z-index: 2;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    width: 26rem;
    height: 6.9rem;
  }

  > .banner-title {
    position: absolute;
    z-index: 3;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    height: 2.5rem;
    text-align: center;
    line-height: 2.5rem;
    font-size: 1.8rem;
    font-weight: bold;
    color: #4a384a;
  }
}

#info {
  position: relative;
  height: 49.8rem;

  > .info-logo {
    position: absolute;
    top: 2.4rem;
    left: 1.2rem;
    width: 17.4rem;
    height: 16.2rem;
  }

  > .info-qrcode {
    position: absolute;
    top: 2.4rem;
    right: 4.8rem;
    width: 10.6rem;
    height: 10.6rem;
  }

  > .info-qrcode-desc {
    position: absolute;
    top: 13.1rem;
    right: 3.2rem;
    width: 13.7rem;
    text-align: center;
    line-height: 1.7rem;
    font-size: 1.2rem;
    color: #999;
  }

  > .info-qrcode-wetchat {
    position: absolute;
    top: 17.1rem;
    right: 1.5rem;
    width: 17.2rem;
    text-align: center;
    line-height: 2rem;
    font-size: 1.4rem;
  }

  > .info-title {
    position: absolute;
    left: 1.2rem;
    line-height: 2.2rem;
  }

  > .info-desc {
    position: absolute;
    left: 1.2rem;
    line-height: 2rem;
    font-size: 1.4rem;
  }

  > .info-title.name {
    top: 20.6rem;
  }

  > .info-desc.name {
    top: 23.2rem;
  }

  > .info-title.address {
    top: 27.2rem;
  }

  > .info-desc.address {
    top: 29.8rem;
  }

  > .info-title.phone {
    top: 33.8rem;
  }

  > .info-desc.phone-hotline {
    top: 36.6rem;
  }

  > .info-desc.phone-business {
    top: 39.2rem;
  }

  > .info-title.email {
    top: 43.2rem;
  }

  > .info-desc.email {
    top: 46rem;
  }
}

#map {
  height: 31.9rem;

  > .baiduMap {
    height: 100%;

    .map-company {
      font-size: 1.4rem;
      font-weight: bold;
      color: #dd5555;
    }

    .map-address {
      margin-top: 0.5rem;
      font-size: 1.2rem;
    }

    /deep/ .anchorBL {
      display: none;
    }
  }
}

.append {
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 5.7rem;
  height: calc(5.7rem + constant(safe-area-inset-bottom));
  height: calc(5.7rem + env(safe-area-inset-bottom));
  background-color: #fff;
  box-shadow: inset 0rem 0.05rem 0rem 0rem #F0F0F0;
  z-index: 96;
  padding: 0 1.6rem;
  display: flex;
  justify-content: space-between;
  align-items: center;

  > .left {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    height: 4rem;

    > img {
      width: 2.4rem;
      height: 2.4rem;
    }

    > p {
      font-size: 1rem;
      color: #333333;
      line-height: 1rem;
    }
  }

  > .right {
    margin-left: 3rem;
    flex: 1;
    height: 4rem;
    background: #7F4DC9;
    border-radius: 5rem 5rem 5rem 5rem;
    font-weight: 500;
    font-size: 1.4rem;
    color: #FFFFFF;
    line-height: 4rem;
    text-align: center;
  }
}

.fill-content {
  width: 27rem;
  height: 28.7rem;
  border-radius: 1.2rem;
  background: #FFFFFF;
  position: relative;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
  padding: 2rem;

  >.title {
    font-size: 1.8rem;
    color: #000000;
    line-height: 2.5rem;
    text-align: center;
    margin-bottom: 2rem;
  }

  >.fill-form {
    margin-bottom: 1.2rem;
    >.input {
      width: 100%;
      height: 4rem;
      background: #FFFFFF;
      border-radius: 0.8rem 0.8rem 0.8rem 0.8rem;
      border: 0.1rem solid #E2E2E2;
      font-weight: 400;
      font-size: 1.4rem;
      color: #333333;
      line-height: 2rem;
      padding: 0 1.2rem;

      &::placeholder {
        font-weight: 400;
        font-size: 1.4rem;
        color: #BCBCBC;
        line-height: 2rem;
      }
    }
  }

  >.error-text {
    position: absolute;
    margin-top: -0.8rem;
    font-size: 1.2rem;
    color: #E74040;
    line-height: 1.7rem;
  }

  >.submit-btn {
    width: 100%;
    margin-top: 2.3rem;
    height: 4rem;
    background: #7254BC;
    border-radius: 2rem;
    font-size: 1.6rem;
    color: #FFFFFF;
    line-height: 4rem;
    text-align: center;
  }

  >.tip {
    margin-top: 1.2rem;
    font-size: 1.2rem;
    color: #999999;
    line-height: 1.7rem;

    >span {
      font-size: 1.2rem;
      color: #7254BC;
      line-height: 1.7rem;
    }
  }

  > .close {
    position: absolute;
    top: 0.8rem;
    right: 0.8rem;
    width: 2.4rem;
    height: 2.4rem;
  }
}
.fill-success {
  width: 27rem;
  height: 16.7rem;
  border-radius: 1.2rem;
  background: #FFFFFF;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);

  > .icon {
    margin-bottom: 1.2rem;
    width: 5rem;
  }

  >.text {
    font-size: 1.8rem;
    color: #000000;
    line-height: 2.5rem;
  }

  > .close {
    position: absolute;
    top: 0.8rem;
    right: 0.8rem;
    width: 2.4rem;
    height: 2.4rem;
  }
}
</style>
